import { useMutation } from "urql";

import { UpdateDeskCollectionDocument } from "../../../../graphql/generated.ts";

export function useUpdateDeskCollection() {
  return useMutation(UpdateDeskCollectionDocument);
}
